module.exports = __webpack_public_path__ + "img/icono-boton-whatsapp.ffc9ed55.svg";